import { useCallback } from "react";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import useFeatureTags from "@custom-hooks/useFeatureTags";
import func from "@uikit/func";
import { useSignal } from "@preact/signals-react";

export function useAISaasPreviewItem() {
  const { enablePreviewToolBar } = useFeatureTags();
  const { aiSaasPreviewHoverData: previewHoverData, isShare } = useHomeUsePluginContainer();
  const setPreviewHoverData = useCallback(
    (val: any) => {
      previewHoverData.value = val;
    },
    [previewHoverData]
  );

  const onPreviewItemMouseEnter = (param: any) => {
    if (enablePreviewToolBar() === false || isShare) return;

    if (func.isEmpty(param.container)) return;

    setPreviewHoverData({ show: true, ...param });
  };

  const onPreviewItemMouseLeave = (e: any) => {
    if (enablePreviewToolBar() === false) return;

    if (e?.relatedTarget?.className?.includes?.("toolbar-main")) return;

    setPreviewHoverData({
      show: false,
      container: null,
      type: "",
    });
  };
  return {
    previewHoverData: previewHoverData.value,
    setPreviewHoverData,
    onPreviewItemMouseEnter,
    onPreviewItemMouseLeave,
  };
}
